import React, { useState, useEffect } from 'react';
import {getFeaturedProducts} from '../../services/firebase';
import { ProductType } from '../../types/product';

const FeaturedProducts: React.FC = () => {
    const [products, setProducts] = useState<ProductType[]>([]);
    useEffect(() => {
        // Fetching products and storing in desc order to show latest created at top of grid
         (async () => {
            try {
              const shopList = await getFeaturedProducts();
              setProducts(shopList);
            } catch (err) {
              console.error("Failed to fetch products:", err);
            }
          })();
      }, []);

    const handleNavigate = (url: string) => {
        window.open(url, '_blank');
    };
    
    if(products.length === 0) return null;
    return(
        <section className="ourShop">
            <div className="wrapper">
                <div className='sectionHeading'>
                    <strong>Shop the Gear</strong>
                    <a href="https://shop.fantasyloser.com" target="_blank" className="moreLink">View All</a>
                </div>
                <ul>
                    {
                        products.map((product: ProductType) => (
                            <li key={product.id}>
                                <div className="shopImg">
                                    <img src={product.image ? product.image : ''} alt={product.title} />
                                </div>
                                <div className="productName">{product.title}</div>
                                <button className='btnStyle btnFilled' onClick={() => handleNavigate(product.url)}>SHOP NOW</button>
                            </li>
                        ))
                    }
                
                </ul>
            </div>
        </section>
    );
};

export default FeaturedProducts;